import α from 'color-alpha';
import interpolate from 'color-interpolate';
import numbro from 'numbro';
import React from 'react';

interface Props {
  concern: number;
}
const ConcernBar: React.FC<Props> = ({ concern }) => {
  const WIDTH = 400,
    HEIGHT = 90;
  concern = Math.min(1, concern);

  const BAR_WIDTH = (WIDTH / 10) * 6;
  const BAR_HEIGHT = WIDTH / 40;
  const BAR_RIGHT_MARGIN = WIDTH / 40;
  const BAR_ORIGIN_X = WIDTH / 20;
  const BAR_ORIGIN_Y = HEIGHT / 2 - BAR_HEIGHT / 2;
  const FONT_SIZE = Math.round(HEIGHT * 0.4);
  const colormap = interpolate([
    '#FF013A',
    '#FF7F23',
    '#FFB637',
    '#77B924',
    '#00B96E',
  ]);

  const width1 = BAR_WIDTH * concern;
  const width2 = BAR_WIDTH * (1 - concern);

  return (
    <svg viewBox={`0 0 ${WIDTH} ${HEIGHT}`}>
      <rect
        x={BAR_ORIGIN_X}
        y={BAR_ORIGIN_Y}
        width={width1}
        height={BAR_HEIGHT}
        style={{
          fill: colormap(2 * (Math.max(0.5, concern) - 0.5)),
        }}
      />
      <rect
        x={BAR_ORIGIN_X + width1}
        y={BAR_ORIGIN_Y}
        width={width2}
        height={BAR_HEIGHT}
        style={{
          fill: α('#128DFA', 0.3),
        }}
      />
      <text
        x={BAR_ORIGIN_X + BAR_WIDTH + BAR_RIGHT_MARGIN}
        y={HEIGHT / 2 + FONT_SIZE / 4}
        fontSize={FONT_SIZE}
      >
        {numbro(concern).format({
          totalLength: 3,
          output: 'percent',
        })}
      </text>
    </svg>
  );
};

export default React.memo(ConcernBar);
